import script from "./artmisadsSegmentedTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./artmisadsSegmentedTabs.vue?vue&type=script&setup=true&lang=js"

import "./artmisadsSegmentedTabs.vue?vue&type=style&index=0&id=690d58c6&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-690d58c6"]])

export default __exports__